import { Col, Icon, message, Row, Steps } from "antd";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import { ResultMessage } from "components/ResultMessage";
import moment from "moment";
import ListItem from "pages/exam/components/ListItem";
import React from "react";
import { useParams } from "react-router-dom";
import { deleteExamFlag, ExamInfoByStuItem, saveExamFlag } from "service/exam";
import { errorMessage } from "service/service";
import AccessoryList from "./components/AccessoryList";
import ImageRecord from "./components/ImageRecord";
import style from "./index.module.scss";

interface MarkRecordProps {
    data: ExamInfoByStuItem;
    updateExamInfo?: () => void; //刷新监考详情
    studentNo: string;
}

export default function MarkRecord({
    data,
    updateExamInfo,
    studentNo
}: MarkRecordProps) {
    const { firstStartTime, submitTime, joinInTime, examTime } = data;
    const format = "YYYY-MM-DD HH:mm";
    const { Step } = Steps;

    const { examId } = useParams<{ examId: string }>();

    //保存标记
    const handleSaveExamFlag = async (flag: string, id?: number) => {
        const params = {
            id,
            studentNo,
            flag,
            examId
        };
        try {
            await saveExamFlag(params);
            message.success("保存成功");
            updateExamInfo && updateExamInfo();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    //删除标记
    const handleDelete = async (id: number) => {
        try {
            await deleteExamFlag(id);
            message.success("删除成功");
            updateExamInfo && updateExamInfo();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    return (
        <div className={style.root}>
            <Row gutter={[0, 20]}>
                <Col span={5} className={style.label}>
                    打开试卷时间：
                </Col>
                <Col className={style.info}>
                    {firstStartTime
                        ? moment(firstStartTime).format(format)
                        : "--"}
                </Col>
            </Row>
            <Row gutter={[0, 20]}>
                <Col span={5} className={style.label}>
                    提交试卷时间：
                </Col>
                <Col className={style.info}>
                    {submitTime ? moment(submitTime).format(format) : "--"}
                    <span className={style.tip}>
                        （提交试卷时间是学生成功提交考试的时间或是判分老师替考生收卷的时间）
                    </span>
                </Col>
            </Row>
            <Row gutter={[0, 20]}>
                <Col span={5} className={style.label}>
                    作答总时长：
                </Col>
                <Col className={style.info}>
                    {joinInTime !== null ? joinInTime + "分钟" : "--"}
                    <span className={style.tip}>
                        （如果判分老师替考生收卷，那么该考生的作答总时长会大于考试时长）
                    </span>
                </Col>
            </Row>
            <Row gutter={[0, 20]}>
                <Col span={5} className={style.label}>
                    考试时长：
                </Col>
                <Col className={style.info}>
                    {examTime !== null ? examTime + "分钟" : "--"}
                </Col>
            </Row>
            <Row gutter={[0, 20]}>
                <Col span={5} className={style.label}>
                    标记异常：
                </Col>
                <Col span={18}>
                    {data.flagList.length === 0 && (
                        <div className={style.info}>暂无异常</div>
                    )}
                    {data.flagList.length !== 0 &&
                        data.flagList.map(item => (
                            <ListItem
                                key={item.id}
                                {...item}
                                onSaveExamFlag={handleSaveExamFlag}
                                onDelete={handleDelete}
                            />
                        ))}
                </Col>
            </Row>
            <Row gutter={[0, 20]}>
                <Col span={5} className={style.label}>
                    补传附件：
                </Col>
                <Col span={17}>
                    {data.allExtraFile.length === 0 && (
                        <div className={style.info}>暂无附件</div>
                    )}
                    {data.allExtraFile.length !== 0 &&
                        data.allExtraFile.map(item => (
                            <AccessoryList
                                key={item.id}
                                {...item}
                                updateExamInfo={updateExamInfo}
                            />
                        ))}
                </Col>
            </Row>
            <Row gutter={[0, 20]}>
                <Col span={5} className={style.label}>
                    参考前采集：
                </Col>
                <Col span={17}>
                    <div className={style.tip}>
                        （启用了摄像头抓拍后，考生的摄像头正常的情况才有采集记录）
                    </div>
                    {data.examBefore.length === 0 && (
                        <CustomEmpty
                            className={style.empty}
                            description={"暂无图像"}
                        />
                    )}
                    {data.examBefore.length !== 0 && (
                        <div className={style.record}>
                            {data.examBefore.map(item => (
                                <ImageRecord
                                    key={Math.random()}
                                    photoData={item}
                                />
                            ))}
                        </div>
                    )}
                </Col>
            </Row>
            <Row gutter={[0, 20]}>
                <Col span={5} className={style.label}>
                    抓拍记录：
                </Col>
                <Col span={19}>
                    <div className={style.tip}>
                        （考生作答期间，系统每 5
                        分钟进行一次考生人脸抓拍，考生是无感知的）
                    </div>
                    {data.examIn.length === 0 && (
                        <CustomEmpty
                            className={style.empty}
                            description={"暂无记录"}
                        />
                    )}
                    {data.examIn.length !== 0 && (
                        <div className={style.record}>
                            {data.examIn.map(item => (
                                <ImageRecord
                                    key={Math.random()}
                                    photoData={item}
                                />
                            ))}
                        </div>
                    )}
                </Col>
            </Row>
            <Row gutter={[0, 20]}>
                <Col span={5} className={style.label}>
                    提交试卷后采集：
                </Col>
                <Col span={17}>
                    <div className={style.tip}>
                        （启用了摄像头抓拍后，考生的摄像头正常的情况才有采集记录）
                    </div>
                    {data.examAfter.length === 0 && (
                        <CustomEmpty
                            className={style.empty}
                            description={"暂无图像"}
                        />
                    )}
                    {data.examAfter.length !== 0 && (
                        <div className={style.record}>
                            {data.examAfter.map(item => (
                                <ImageRecord
                                    key={Math.random()}
                                    photoData={item}
                                />
                            ))}
                        </div>
                    )}
                </Col>
            </Row>
            <Row gutter={[0, 20]}>
                <Col span={5} className={style.label}>
                    切屏次数：
                </Col>
                <Col span={17}>
                    <div className={style.tip}>
                        （记录考生在考试期间切屏离开考试作答界面的情况，如果考生有切屏行为，系统只是警示，不会强制收卷）
                    </div>
                    {data.allLeaveTime.length === 0 && (
                        <CustomEmpty
                            className={style.empty}
                            description={"无切屏记录"}
                        />
                    )}
                    {data.allLeaveTime.length !== 0 && (
                        <Steps direction="vertical">
                            {data.allLeaveTime.map(item => (
                                <Step
                                    key={Math.random()}
                                    title={moment(item).format(
                                        "MM-DD HH:mm:ss"
                                    )}
                                    description="离开考试页面"
                                    icon={
                                        <Icon
                                            type="clock-circle"
                                            className={style.icon}
                                        />
                                    }
                                />
                            ))}
                        </Steps>
                    )}
                </Col>
            </Row>
        </div>
    );
}
